/**
 *
 * @module refreshGrant
 *
 */

import Check from 'check-types';
import TokenRequestBuilder from './tokenRequestBuilder';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class RefreshGrant
 * @extends {TokenRequestBuilder}
 * @desc Represents the response from exchanging a token and provides
 * access context for subsequent service requests.
 *
 */
export default class RefreshGrant extends TokenRequestBuilder {

    /**
     *
     * @param {String} [refreshToken]
     *
     */
    constructor(refreshToken) {

        const errorMessage = {
            ctor: 'RefreshGrant(refreshToken)',
            get refreshToken() {
                return `${this.ctor} refreshToken should be a String with length`;
            }
        };

        if (Check.assigned(refreshToken)) {
            nonEmptyString(refreshToken, errorMessage.refreshToken, InvalidArgumentException);
        }

        super();

        /**
         *
         * @access public
         * @type {String}
         * @desc The refresh token, which can be used to obtain a new access token.
         *
         */
        this.refreshToken = refreshToken || '';

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.grantType = 'refresh_token';

        /**
         *
         * @desc token data, used in a TokenRequest
         *
         */
        this.tokenData.refresh_token = this.refreshToken;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/refreshGrant.js